import { render, staticRenderFns } from "./detailed-dialog.vue?vue&type=template&id=7be5f08d&scoped=true"
import script from "./detailed-dialog.vue?vue&type=script&lang=js"
export * from "./detailed-dialog.vue?vue&type=script&lang=js"
import style0 from "./detailed-dialog.vue?vue&type=style&index=0&id=7be5f08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5f08d",
  null
  
)

export default component.exports